import { styled } from '@mui/material';

import { useEffect } from 'react';

import { Typography, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { usePricing } from '@app-velocity/config';

import { Plan } from '../Plan';

import { useCreateSubscriptionMutation } from '../../../../queries/useCreateSubscriptionMutation';
import { usePaymentPlansContext } from '../../../../context/usePaymentPlansContext';
import { CurrentPlan } from '../CurrentPlan';

const StyledPrice = styled(Typography)(({ theme }) => ({
  fontSize: 40,
  fontWeight: 700,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  small: {
    fontSize: 13,
    fontWeight: 300,
  },
}));

export const ProPlan = () => {
  const { t } = useI18n();
  const { getPlanPrice } = usePricing();
  const { subscribed, tier } = usePaymentPlansContext();
  const {
    mutate: startSubscription,
    isPending,
    data,
  } = useCreateSubscriptionMutation();

  const onClick = () => {
    startSubscription('pro');
  };

  useEffect(() => {
    if (!data) return;
    const { paymentUrl } = data;

    if (!paymentUrl) return;

    window.open(paymentUrl, '_blank');
  }, [data]);

  return (
    <Plan
      highlighted
      name="payments:plans.pro.title"
      price={
        <StyledPrice>
          {getPlanPrice('pro')}
          <small>{t('payments:per_month')}</small>
        </StyledPrice>
      }
      description={[
        'payments:plans.pro.description.a',
        'payments:plans.pro.description.b',
        'payments:plans.pro.description.c',
        'payments:plans.pro.description.d',
        'payments:plans.pro.description.e',
        'payments:plans.pro.description.f',
        'payments:plans.pro.description.g',
      ]}
      action={
        subscribed && tier === 'PRO' ? (
          <CurrentPlan />
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={onClick}
            disabled={isPending}
          >
            {t('payments:upgrade')}
          </Button>
        )
      }
  />
  );
};
